import { Field, reduxForm } from 'redux-form';
import { LoginButton, LoginButtonDisabled } from '../../../components/buttons';
import React, { Component } from 'react';
import { renderTextField } from '../../../components/reduxFields';
import { connect } from 'react-redux';
// import LoginLogo from '../../../img/loginlogo.png';
// import { NavLink } from 'react-router-dom';
// import { Redirect } from 'react-router-dom';
import { ResetPasswordAction } from './actions/LoginActions';
// import validate from './validate';
import LogoImageViewer from '../../../components/logoImageViewer'; 

class ResetPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      token: props.match.params.token,
    };
  }

  //   componentWillMount() {
  //     let token = this.props.match.params.token;
  //     this.props.verfiyUserToken(token);
  //   }
  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage) {
      let errorMessage = nextProps.errorMessage;
      this.setState({ errorMessage: errorMessage });
    }
  }

  onSubmit(authData) {
    authData = {
      'Password': authData.Password,
      'Token': this.state.token,
    };
    // console.log('ResetpassData---', authData);
    this.props.ResetPasswordAction(authData);
  }

  render() {
    const { handleSubmit, authenticatingToken } = this.props;
    if (authenticatingToken) {
      return (
        <div className="login_bg">
          <div className="login-wrapper">
            <div className="login-fields">
            Loading...Please wait !
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <div className="loginlogo">
            <LogoImageViewer isLoginPage={true} logoUrl={null} businessName={null} />
          </div>
          <div className="login-fields">
            <h3>Reset Password </h3>
            <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              {this.state.errorMessage ?
                <div className="alert-danger">{this.state.errorMessage}</div>
                : '' }
              <div className="row">
                <div className="col-md-12 require">
                  <Field
                    name="Password"
                    type="password"
                    maxLength="30"
                    label="New password"
                    component={renderTextField}/>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 require">
                  <Field
                    name="confirm_password"
                    type="password"
                    maxLength="30"
                    label="Confirm password"
                    component={renderTextField}/>
                </div>
              </div>
              <div className="pt20">
                {this.props.authenticating ? <LoginButtonDisabled label="Reset" /> : <LoginButton label="Reset" />}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticating: state.login.authenticating,
    errorMessage: state.login.errorMessage,
  };
}

function validate(values) {
  const error = {};
  if (!values.Password) {
    error.Password = 'Please enter password';
  }
  if (values.Password) {
    if (values.Password.trim().length < 8) {
      error.Password = 'Please enter minimum 8 characters';
    }
  }
  if (!values.confirm_password) {
    error.confirm_password = 'Please enter confirm password';
  } else if (values.confirm_password !== values.Password) {
    error.confirm_password = 'Confirm password does not match';
  }
  return error;
}

ResetPassword = reduxForm({
  form: 'ResetPasswordForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(ResetPassword);

export default connect(mapStateToProps, { ResetPasswordAction })(ResetPassword);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/logins/reset_password.js